/**
 * PostHog flag gating email as a routine delivery destination in the UI.
 *
 * While this flag is disabled — the default — the Email row is absent from
 * both places that can add recipients: the chat create/update card
 * (`ChannelInputBlockRenderer`) and the routine detail inline editor
 * (`RoutineDeliveryEditor`). Slack and Google Chat ship ungated. Treat
 * `undefined` (flags still loading) as disabled so the row never flashes for
 * gated tenants.
 *
 * Existing data is grandfathered, never hidden or dropped: a routine that
 * already has email recipients (saved while the flag was on, or seeded
 * server-side) still shows its Email row read-and-editable with the flag off —
 * hiding it would silently drop the saved recipients on the next Confirm/Save.
 *
 * UI-only gate: the server-side preference rows, dispatch, and chat tools
 * accept email regardless; this flag controls discoverability while email
 * delivery is validated on staging.
 */
export const ROUTINE_EMAIL_DELIVERY_FLAG = 'routine_email_delivery';
